import { render, staticRenderFns } from "./editSa.vue?vue&type=template&id=3109d222&lang=pug&"
import script from "./editSa.vue?vue&type=script&lang=js&"
export * from "./editSa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports